var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advImage",class:{'mt20':!_vm.isMartop}},[_c('div',{ref:"ad",staticClass:"allyesAdvWrap adv160",attrs:{"id":_vm.advCode}})])}
var staticRenderFns = []

export { render, staticRenderFns }